/* DD Reserve pill · IG-RESERVE-V1
 * AJAX submit → /cart/add.js → open cart drawer via cart:updated event.
 * Idempotent: safe to load once per page even if multiple pills are present.
 */
(function () {
  if (window.__ddReserveInit) return;
  window.__ddReserveInit = true;

  function handleSubmit(form) {
    var btn = form.querySelector('.dd-reserve__btn');
    var labelEl = form.querySelector('.dd-reserve__label');
    var originalLabel = labelEl ? labelEl.textContent : 'Reserve';
    if (!btn) return;

    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Reserving';
    form.classList.remove('is-added', 'is-error');

    var body = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      })
      .then(function (item) {
        form.classList.add('is-added');
        if (labelEl) labelEl.textContent = 'Reserved';

        // Fire every cart-refresh event pattern Horizon / DD custom drawer might listen for
        var evts = ['cart:updated', 'cart:refresh', 'cart:build', 'cart:add', 'cart:change'];
        evts.forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { detail: { source: 'dd-reserve', item: item } }));
        });

        // Bump the header cart count immediately
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var countEls = document.querySelectorAll('.dd-hdr__bag-count, [data-cart-count]');
            countEls.forEach(function (el) { el.textContent = String(cart.item_count); el.style.display = 'inline-flex'; });
          }).catch(function () {});

        // Open the cart drawer — try every known Horizon/DD selector + API
        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer-component')
            || document.querySelector('cart-drawer')
            || document.querySelector('.cart-drawer')
            || document.querySelector('[id*="cart-drawer"]');
          if (drawer) {
            if (typeof drawer.showModal === 'function') { try { drawer.showModal(); return; } catch (e) {} }
            if (typeof drawer.show === 'function')      { try { drawer.show();      return; } catch (e) {} }
            if (typeof drawer.open === 'function')      { try { drawer.open();      return; } catch (e) {} }
            drawer.setAttribute('open', '');
            drawer.classList.add('is-open', 'active');
            drawer.style.display = 'block';
            drawer.hidden = false;
            return;
          }
          // Last-ditch: click the cart icon in the header (Horizon default behaviour)
          var cartLink = document.querySelector('[data-dd-cart-open], .header__icon--cart, a[href="/cart"]');
          if (cartLink) cartLink.click();
        }, 250);

        // Optimistic local counter bump for this handle
        var handle = form.getAttribute('data-dd-reserve-handle');
        if (handle) {
          document.querySelectorAll('[data-dd-reserve-handle="' + handle + '"]').forEach(function (peer) {
            var countEl = peer.querySelector('[data-dd-reserve-count]');
            var barEl   = peer.querySelector('.dd-reserve__bar-fill');
            var quotaEl = peer.querySelector('.dd-reserve__count-quota');
            if (countEl) {
              var n = parseInt(countEl.textContent, 10) || 0;
              countEl.textContent = String(n + 1);
              if (barEl && quotaEl) {
                var q = parseInt(quotaEl.textContent, 10) || 10;
                var pct = Math.min(100, ((n + 1) / q) * 100);
                barEl.style.width = pct + '%';
              }
            }
          });
        }
        setTimeout(function () {
          form.classList.remove('is-added');
          if (labelEl) labelEl.textContent = originalLabel;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        form.classList.add('is-error');
        if (labelEl) labelEl.textContent = 'Try again';
        setTimeout(function () {
          form.classList.remove('is-error');
          if (labelEl) labelEl.textContent = originalLabel;
          btn.disabled = false;
        }, 2200);
      });
  }

  function attach(root) {
    (root || document).querySelectorAll('[data-dd-reserve]').forEach(function (form) {
      if (form.__ddReserveBound) return;
      form.__ddReserveBound = true;
      form.addEventListener('submit', function (e) { e.preventDefault(); handleSubmit(form); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { attach(document); });
  attach(document);

  // Rebind after Shopify section reloads (customizer edits)
  document.addEventListener('shopify:section:load', function (e) { attach(e.target); });
})();
